import {z} from "zod";

export const Style = z.object({
    widths: z.array(z.number().min(1).max(2500)).optional(),
    heights: z.array(z.number().min(1).max(1500)).optional(),
    fit: z.enum(["cover", "contain", "fill"]).default('contain'),
    maxHeight: z.number().min(1).max(1500).optional(),
});

export default z.object({
    src: z.string().or(z.object({
        url: z.string(),
        content_hash: z.string().optional(),
        crop: z.any().optional(),
        origin_height: z.number().optional(),
        origin_width: z.number().optional(),
    })),

    style: Style,

    link: z.object({
        href: z.string().optional(),
        target: z.string().optional(),
        rel: z.string().optional(),
    }).optional()
});
